import type { PropsWithChildren } from "react";
import { useEffect } from "react";
import { useIdleTimer } from "react-idle-timer";
import { useAuth } from "@/hooks/useAuth";

const LOGOUT_TIMEOUT_IN_MINUTES = 60 * 12; // 12 hours

const LOGOUT_TIMEOUT_IN_MILLISECONDS = 1000 * 60 * LOGOUT_TIMEOUT_IN_MINUTES;

export function LogoutIdleTimer(props: PropsWithChildren<any>) {
  const { logout } = useAuth();
  async function onIdle() {
    console.log("Signing out due to inactivity...");
    await logout();
  }

  const { reset: resetTimer } = useIdleTimer({
    onIdle,
    timeout: LOGOUT_TIMEOUT_IN_MILLISECONDS,
  });

  useEffect(() => {
    resetTimer();
  }, [logout]);

  return props.children;
}
